import { camelizeKeys } from 'humps';
import { post, validateScheme } from '@namespace/helpers';
import { apiRoutes } from './apiRoutes';
import {
  getTaxesByCodeResponseSchema,
  getTaxesNewResponseDataSchema,
  getTaxesResponseDataSchema
} from './schemas';
import {
  GetTaxesByCodeRequestParams,
  GetTaxesByCodeResponse,
  GetTaxesNewResponse,
  GetTaxesNewResponseData,
  GetTaxesRequestParams,
  GetTaxesResponseData
} from './types';

export const getTaxes = (props: GetTaxesRequestParams) => {
  return post<GetTaxesResponseData>(apiRoutes.getTaxes, props).then((data) => {
    validateScheme(getTaxesResponseDataSchema, data, { name: 'getTaxes' });
    return camelizeKeys<GetTaxesResponseData['response']>(data.response);
  });
};

export const getTaxesNew = (props: GetTaxesRequestParams) =>
  post<GetTaxesNewResponseData>(apiRoutes.getTaxesNew, props).then((data) => {
    validateScheme(getTaxesNewResponseDataSchema, data, {
      name: 'getTaxesNew'
    });
    return camelizeKeys<GetTaxesNewResponse>(data.response);
  });

export const getTaxesByCode = (props: GetTaxesByCodeRequestParams) =>
  post<GetTaxesByCodeResponse>(apiRoutes.getTaxesByCode, props).then(
    (response) => {
      validateScheme(getTaxesByCodeResponseSchema, response, {
        name: 'getTaxesByCode'
      });
      return camelizeKeys<GetTaxesByCodeResponse>(response);
    }
  );
